@let disabled = disabled$ | async;
@let hasRequired = control | controlHasRequired;
<app-control-wrapper
  [control]="control"
  [officeField]="officeField"
  [formGroupInstance]="formGroupInstance"
  [errorsMessagesOverridesRegistry]="errorsMessagesOverridesRegistry"
  [required]="hasRequired"
  [validating]="validating$()"
  [disabled]="disabled || validating$()"
  [touched]="isTouched$ | async"
  [dirty]="isDirty$ | async"
  [alignment]="alignment"
  [config]="config">
  <select
    #select
    class="form-control"
    [formControl]="control"
    [name]="officeField.VistaFormItem.ColumnName ? '' : null"
    (change)="select.blur()"
    [attr.disabled]="disabled ? '' : null">
    <option *ngIf="!hasRequired || (hasRequired && !control.value)" [value]=""></option>
    @for (item of comboBoxItems$(); track item.DatabaseValue) {
      <option [value]="item.DatabaseValue">
        {{ item.DisplayValue }}
      </option>
    }
  </select>
</app-control-wrapper>
